module.exports = __webpack_public_path__ + "img/branch-icon-dark.2417163d.svg";